import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button } from "antd";
import {
  Row,
  Form,
  Input,
  Col,
  Select,
  Collapse,
  notification,
  Popconfirm,
} from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  MinusCircleTwoTone,
  PlusCircleTwoTone,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import SensorApi from "../../common/Apis/SensorApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
const Sensor = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Sensors, setSensors] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    SensorApi.ListSensors(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setSensors(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    SensorApi.ListSensors(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setSensors(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getSensors = useCallback(() => {
    SensorApi.ListSensors(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setSensors(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getSensors();
  }, [PageLoading]);


  const handleRemovefilterStorage = (FiltergetStorageIndex) => {
    const newfilterStorage = [...filterStorage];
    newfilterStorage.splice(FiltergetStorageIndex, 1);
    setFilterStorage(newfilterStorage);
    if (FiltergetStorageIndex == 0) {
    }
  };
  const handleClear = () => {
    setIsLoading(true);
    getSensors()
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterStorage([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterStorage, setFilterStorage] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterStorage = () => {
    setFilterStorage([
      ...filterStorage,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterStorage
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
      "componentCode=SENSOR&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString

    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setSensors(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FiltergetStorageIndex, value) => {
    const newfilterStorage = [...filterStorage];
    newfilterStorage[FiltergetStorageIndex].title = value;
    setFilterStorage(newfilterStorage);
  };
  const handleChangeAnswertype = (FiltergetStorageIndex, value) => {
    const newfilterStorage = [...filterStorage];
    newfilterStorage[FiltergetStorageIndex].answerType = value;
    setFilterStorage(newfilterStorage);
  };

  const handleChangename = (FiltergetStorageIndex, value) => {
    const newfilterStorage = [...filterStorage];
    newfilterStorage[FiltergetStorageIndex].name = value;
    setFilterStorage(newfilterStorage);
  };

  const paginatedData = Sensors;

  const handleDeleteStorage = (SensorID) => {
    SensorApi.DeleteSensors(SensorID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getSensors();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">

          <td className="pt-3">
            {item?.name}
          </td>

          <td style={{ width: "5%" }}>
            <div className="d-flex ">
              <Link
                to={`/masters/sensor/edit-sensor?id=${item?.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_SENSOR'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Sensor ?"
                okText="Yes"
                placement="topRight"
                onConfirm={() => handleDeleteStorage(item.id)}
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_SENSOR'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={2} className="text-center ">
            <EmptyBox />
            <br />
            {/* <Button
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_SENSOR'
              ) ? 'btn btn-primary btn-save m-0 my-2 mt-4 ' : 'd-none'}
              href={"/masters/sensor/add-sensor"}
            >
              Add Sensor
            </Button> */}
            <Button
              type="primary"
              onClick={() => navigate("/masters/sensor/add-sensor")}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_SENSOR'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add new sensor
            </Button>
          </td>
        </tr>
      );
    }
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterStorage.map((input, filterStorageIndex) => (
                    <div key={filterStorageIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterStorageIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterStorageIndex, value)
                              }
                              options={[
                                {
                                  value: "name",
                                  label: "Sensor Name",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item
                            name={`type${filterStorageIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(
                                  filterStorageIndex,
                                  value
                                )
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={5}>
                          <Form.Item
                            name={`name${filterStorageIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterStorageIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterStorageIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterStorage}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterStorage(
                                      filterStorageIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData?.length > 0 && (
                  <Button
                    className={decodedToken?.permissions?.some(
                      (permission) => permission?.authority === 'ADD_STORAGE'
                    ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                    style={{ height: '40px', alignItems: 'center', padding: '7px 24px' }}
                    href={"/masters/sensor/add-sensor"}
                  >
                    Add Sensor
                  </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Sensor Name</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Sensor;
